<template>
  <Header />
  <div class="personal-info-activation-wrapper">
    <!-- col starts here -->
    <div class="container">
      <div class="row my-4">
        <div class="col-lg-5">
          <div class="bg-white py-3 px-3 rounded-4"></div>
        </div>
        <div class="col-lg-7">
          <div class="personal-info-col bg-white py-3 px-3 rounded-4">
            <div class="form-container-row-personal-info">
              <h2>Who is this kit for?</h2>

              <!-- 3 col starts here -->
              <div class="personal-info-checkbox-row">
                <div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      checked
                    />
                    <label class="form-check-label" for="flexRadioDefault2">
                      Myself
                    </label>
                  </div>
                </div>
                <div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      checked
                    />
                    <label class="form-check-label" for="flexRadioDefault2">
                      My child (Under 18)
                    </label>
                  </div>
                </div>
                <div>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      checked
                    />
                    <label class="form-check-label" for="flexRadioDefault2">
                      Someone else
                    </label>
                  </div>
                </div>
              </div>
              <!-- 3 col ends here -->

              <form class="personal-form-row">
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label text-left"
                    >First name</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="First name"
                  />
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label text-left"
                    >Last name</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="exampleFormControlInput1"
                    placeholder="Last name"
                  />
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label text-left"
                    >Country of Birth</label
                  >
                  <select class="form-select" aria-label="Default select example">
                    <option selected>Choose Country</option>
                    <option value="1">India</option>
                    <option value="2">USA</option>
                    <option value="3">Thailand</option>
                    <option value="4">Pakistan</option>
                    <option value="5">Sri Lanka</option>
                    <option value="6">Bangladesh</option>
                    <option value="7">Thailand</option>
                  </select>
                </div>

                <!-- col starts here -->
                <div class="dob-row">
                  <div>
                    <div class="mb-3">
                      <label for="exampleFormControlInput1" class="form-label text-left"
                        >Bilogical Sex</label
                      >
                      <select class="form-select" aria-label="Default select example">
                        <option selected>Choose Gender</option>
                        <option value="1">Male</option>
                        <option value="2">Female</option>
                        <option value="3">Others</option>
                      </select>
                    </div>
                  </div>
                  <div>
                    <label for="exampleFormControlInput1" class="form-label text-left"
                      >Date of Birth (MM/DD/YYYY)</label
                    >
                    <!-- 3 col starts here -->
                    <div class="dob-col-row">
                      <div>
                        <div class="mb-3">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Month"
                          />
                        </div>
                      </div>
                      <div>
                        <div class="mb-3">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Date"
                          />
                        </div>
                      </div>
                      <div>
                        <div class="mb-3">
                          <input
                            type="text"
                            class="form-control"
                            id="exampleFormControlInput1"
                            placeholder="Year"
                          />
                        </div>
                      </div>
                    </div>
                    <!-- 3 col ends here -->
                  </div>
                </div>
                <!-- col ends here -->

                <!-- checkbox -->
                <div class="form-check mt-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    checked
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    Person is living
                  </label>
                </div>

                <div class="form-check mt-2">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    id="flexCheckChecked"
                    checked
                  />
                  <label class="form-check-label" for="flexCheckChecked">
                    I have their explicit consent to manage their DNA data
                  </label>
                </div>
                <!-- checkbox -->

                <button class="activate-kit-cta btn btn-primary w-100 mt-4">
                  Activate Kit
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- col ends here -->
  </div>
</template>
<script setup>
import Header from "@/components/header/Header.vue";

import "../../styles/pages/Activation.scss";
</script>
